type ViewSuggestedPlacesEventArgs = {
  query: string
  count: number | null
  sessionToken: string
  screen: string
}

export const viewSuggestedPlacesEvent = (args: ViewSuggestedPlacesEventArgs) => {
  const { query, count, sessionToken, screen } = args

  return {
    event: 'user.autocomplete_results',
    extra: {
      query,
      count,
      session_token: sessionToken,
      screen,
    },
  }
}

type SelectSuggestedPlaceEventArgs = {
  selectedAutocomplete: string
  sessionToken: string
  screen: string
}

export const selectSuggestedPlaceEvent = (args: SelectSuggestedPlaceEventArgs) => {
  const { selectedAutocomplete, sessionToken, screen } = args

  return {
    event: 'user.autocomplete_details',
    extra: {
      selected_autocomplete: selectedAutocomplete,
      session_token: sessionToken,
      screen,
    },
  }
}

// Source: https://github.com/vinted/dwh-schema-registry/blob/bd07d3e78b3951daa9328387bfb31631397574ae/avro/events/shipping_options/click.avdl#L28
type ShippingClickEventTarget = 'pickup_point_search_result' | 'pickup_point_search_click'

type ShippingClickEventArgs = {
  screen: string
  checkoutId: string
  target: ShippingClickEventTarget
  valid?: boolean
  info?: string
  infoPii?: string
}

type ShippingClickEventExtra = {
  screen: string
  checkout_id: string
  target: string
  valid?: boolean
  info?: string
  info_pii?: string
}

export const shippingClickEvent = (args: ShippingClickEventArgs) => {
  const { screen, checkoutId, valid, target, info, infoPii } = args

  const extra: ShippingClickEventExtra = {
    screen,
    checkout_id: checkoutId,
    valid,
    target,
    info,
    info_pii: infoPii,
  }

  return { event: 'shipping_options.click', extra }
}
